import Main from './UsersMain'
import New from './UsersNew'
import Edit from './UsersEdit'

export default {
  Main,
  New,
  Edit,
}
